import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, normalizeStyle, renderSlot } from "vue";
import { p as pick } from "../../../../utils/pick.js";
import { u as useAlignProps, a as useAlign } from "../../../../composables/useAlign.js";
import { u as useComponentPresetProp } from "../../../../composables/useComponentPreset.js";
import { u as useBem } from "../../../../composables/useBem.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaCardActions"
  },
  __name: "VaCardActions",
  props: {
    ...useAlignProps,
    ...useComponentPresetProp
  },
  setup(__props) {
    const props = __props;
    const { alignComputed } = useAlign(props);
    const classComputed = useBem("va-card__actions", () => ({
      ...pick(props, ["vertical"])
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["va-card__actions", unref(classComputed)]),
        style: normalizeStyle(unref(alignComputed))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 6);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../../VaCardActions.css';
//# sourceMappingURL=VaCardActions.vue_vue_type_script_setup_true_lang.js.map
